import { API_METHODS, API_URL, MAX_API_TIMEOUT } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
export const getReportOverview = async (payload: any = {}) => {
  const filterUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.REPORT}?reportName=${payload.reportName}`;
  const config: any = {
    method: API_METHODS.POST,
    url: filterUrl,
    data: payload.data,
    timeout: MAX_API_TIMEOUT,
    // Prevent the global spinner/loader from showing for the report overview call
    hideSpinner: true,
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};
